
// 新版协议返回结果进行base64解码
const Base64 = {
    _keyStr: "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=",
    encode: function (e) {
        var t = "";
        var n, r, i, s, o, u, a;
        var f = 0;
        var e = Base64._utf8_encode(e);
        while (f < e.length) {
        n = e.charCodeAt(f++);
        r = e.charCodeAt(f++);
        i = e.charCodeAt(f++);
        s = n >> 2;
        o = (n & 3) << 4 | r >> 4;
        u = (r & 15) << 2 | i >> 6;
        a = i & 63;
        if (isNaN(r)) {
            u = a = 64;
        } else if (isNaN(i)) {
            a = 64;
        }
        t = t + this._keyStr.charAt(s) + this._keyStr.charAt(o) + this._keyStr.charAt(u) + this._keyStr.charAt(a);
        }
        return t;
    },
    decode: function (e) {
        var t = "";
        var n, r, i;
        var s, o, u, a;
        var f = 0;
        e = e.replace(/[^A-Za-z0-9+/=]/g, "");
        while (f < e.length) {
        s = this._keyStr.indexOf(e.charAt(f++));
        o = this._keyStr.indexOf(e.charAt(f++));
        u = this._keyStr.indexOf(e.charAt(f++));
        a = this._keyStr.indexOf(e.charAt(f++));
        n = s << 2 | o >> 4;
        r = (o & 15) << 4 | u >> 2;
        i = (u & 3) << 6 | a;
        t = t + String.fromCharCode(n);
        if (u != 64) {
            t = t + String.fromCharCode(r);
        }
        if (a != 64) {
            t = t + String.fromCharCode(i);
        }
        }
        t = Base64._utf8_decode(t);
        return t;
    },
    _utf8_encode: function (e) {
        e = e.replace(/rn/g, "n");
        var t = "";
        for (var n = 0; n < e.length; n++) {
        var r = e.charCodeAt(n);
        if (r < 128) {
            t += String.fromCharCode(r);
        } else if (r > 127 && r < 2048) {
            t += String.fromCharCode(r >> 6 | 192);
            t += String.fromCharCode(r & 63 | 128);
        } else {
            t += String.fromCharCode(r >> 12 | 224);
            t += String.fromCharCode(r >> 6 & 63 | 128);
            t += String.fromCharCode(r & 63 | 128);
        }
        }
        return t;
    },
    _utf8_decode: function (e) {
        var t = "";
        var n = 0;
        var r = 0;
        var c1 = 0;
        var c2 = 0;
        var c3 = 0;
        while (n < e.length) {
        r = e.charCodeAt(n);
        if (r < 128) {
            t += String.fromCharCode(r);
            n++;
        } else if (r > 191 && r < 224) {
            c2 = e.charCodeAt(n + 1);
            t += String.fromCharCode((r & 31) << 6 | c2 & 63);
            n += 2;
        } else {
            c2 = e.charCodeAt(n + 1);
            c3 = e.charCodeAt(n + 2);
            t += String.fromCharCode((r & 15) << 12 | (c2 & 63) << 6 | c3 & 63);
            n += 3;
        }
        }
        return t;
    }
}

// 调用旧协议
function kkhybrid_requestapi(param, callback) {
    const dataType = param.data_type == 'json' ? '0' : '1';
    hybrid({
        hybridParam: {
            schema: 'kkhybrid',
            tagname: 'requestapi'
        },
        param:{
            type: param.method,
            param: param.data,
            url: param.url,
            dataType
        },
        callback: function (res) {
            const {code, data, message} = res;
            if (code == 200) {
                callback && callback({
                    code: 200,
                    message: 'ok',
                    data: {
                        code: 200,
                        result: res
                    }
                });
            } else {
                callback && callback({
                    code,
                    message,
                    data: {
                        code: '',
                        result: ''
                    }
                });
            }
        }
    });
}

// 调用新协议
function kkmhhybrid_request_api(param, callback) {
    hybrid({
        hybridParam: {
            schema: 'kkmhhybrid',
            tagname: 'request_api'
        },
        param,
        callback: function (res) {
            const {code, data, message} = res;
            if (code == 200) {
                if (data.code == 200) {
                    const result = data.result || '';
                    const params = Base64.decode(result);
                    callback && callback({
                        code,
                        message,
                        data: {
                            result: JSON.parse(params),
                            code: 200
                        }
                    });
                } else {
                    callback && callback(res);
                }
            } else {
                callback && callback(res);
            }
        }
    });
}

/**
 * 代理请求
 * @param {Object} opt 参数对象
 * @param {String} opt.method 请求类型
 * @param {String} opt.url 请求地址
 * @param {Object} opt.data 请求参数
 * @param {String} opt.data_type 请求数据类型
 * @param {Function} opt.callback 回调函数
 * @param {Number} criticalAppVersion 新旧协议兼容的判断版本（默认值在hybrid/index.js里配置）
 */
function request_api (opt = {}, criticalAppVersion) {

    const {
        method = 'get',
        url = '',
        data_type = 'json',
        data = {},
        callback = () => {}
    } = opt;
    const allow = window.kkBaseInfo.allowToKkmhhybrid(criticalAppVersion)

    if (allow) {
        kkmhhybrid_request_api({
            method, 
            url, 
            data_type, 
            data
        }, callback);
    } else {
        kkhybrid_requestapi({
            method, 
            url, 
            data_type, 
            data
        }, callback);
    }
}

export default request_api;


// WEBPACK FOOTER //
// ./node_modules/@kk/h5-sdk/src/request_api/index.js